import { useState,useEffect } from "react";
import DashboardCard from "../../Component/dashbord/DashboardCard";
import moment from "moment";
import { baseUrl } from "../../utils/apiActions/dashboardApi";

const Dashboard = () => {
  const [locationId, setLocationId] = useState();
  const [isLoading, setIsLoading] = useState(false);
  const [accounts, setAccounts] = useState([]);
  const user = JSON.parse(localStorage.getItem("user"));
  const currentDate = moment(); // current date and time
  const firstDayOfMonth = moment().startOf("month"); // first day of the current month

  const toDate = currentDate.format("YYYY-MM-DD");
  const fromDate = firstDayOfMonth.format("YYYY-MM-DD");
  useEffect(() => {
    setIsLoading(true);
    const url = `${baseUrl}/reports/daily/accounts?location=${user.location_id}&startdate=${fromDate}&enddate=${toDate}`;
    fetch(url, {
      method: "GET",
      headers: new Headers({
        Authorization: "Bearer " + user.access_token,
        Accept: "application/json",
        "Content-Type": "application/json",
      }),
    })
      .then((res) => res.json())
      .then((res) => {
        setIsLoading(false);
        setAccounts(res);
      })
      .catch((err) => {
        console.log(err);
      });
  }, [locationId]);
  return (
    <div>
      <DashboardCard
        accounts={accounts}
        houses={"40,000"}
        targets={"60M"}
        collections={"45M"}
        outstanding={"15M"}
        transfers={"40M"}
        isAccountLoading={isLoading}
      />
    </div>
  );
};

export default Dashboard;
